import { PaginationState, SortingState } from '@tanstack/react-table';
import Table from 'library/molecules/Tablev2/Table';
import { useEffect, useRef, useState } from 'react';
import { AnalyticsTableProps } from './types';

function AnalyticsTable<T>(props: AnalyticsTableProps<T>) {
  const {
    columns,
    selectors,
    data,
    pageCount,
    pageIndex,
    pageSize,
    onPaginationChange,
    onSortChange,
    isLoading,
    sorting,
    maxPageSize = 8,
  } = props;

  const [pagination, setPagintion] = useState<PaginationState>({
    pageSize,
    pageIndex,
  });

  const [sort, setSort] = useState<SortingState>(sorting);

  useEffect(() => {
    setPagintion({
      pageSize,
      pageIndex,
    });
  }, [pageSize, pageIndex]);

  useEffect(() => {
    onPaginationChange(pagination);
  }, [pagination]);

  useEffect(() => {
    setSort(sorting);
  }, [sorting]);

  const isInitialRender = useRef(true);

  useEffect(() => {
    if (!isInitialRender.current) {
      onSortChange(sort);
    }
    isInitialRender.current = false;
  }, [sort]);

  const analyticsTableColumns = selectors ? [selectors, ...columns] : columns;

  return (
    <Table
      columns={analyticsTableColumns}
      data={data}
      pageCount={pageCount || 0}
      pageIndex={pagination.pageIndex}
      pageSize={pagination.pageSize}
      onPaginationChange={setPagintion}
      showNumberBasedPagination
      onSortingChange={setSort}
      sorting={sort}
      isLoading={isLoading}
      maxPageSize={maxPageSize}
      tbody={{
        '& tr td:first-child': {
          paddingRight: '0px',
        },
      }}
      headerStyle={{
        paddingRight: '0px',
      }}
      thead={{
        '& tr th': {
          paddingRight: '0px',
        },
      }}
    />
  );
}

export default AnalyticsTable;
